export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_32-3e190348fe96437e31fe48fcc563cef6.jpg";